__turbopack_context__.v({
  "kitPageContent": "page-module__4Fu-uW__kitPageContent",
  "kitProductsTitle": "page-module__4Fu-uW__kitProductsTitle",
  "otherKits": "page-module__4Fu-uW__otherKits",
  "otherKitsTitle": "page-module__4Fu-uW__otherKitsTitle",
});
